import cl from "./ProductCard.module.css";
import { Link, NavLink, useParams } from "react-router-dom";
import React, { useState } from "react";
import Comments from "../../../Comments/Comments";

const ProductCard = (props) => {
  const productPath = useParams().path;
  const product = props.productsData.find(
    (product) => product.path === encodeURIComponent(productPath)
  );
  const image = product.images ? product.images[0] : null;
  const [mainImage, setMainImage] = useState(image);

  const onMouseOver = (img) => () => {
    setMainImage(img);
  };
  let productDescrImages = product.imagesAbout?.map((p) => (
    <img className={cl.description_image} src={p} />
  ));
  let newPrice = ((product.oldPrice * (100 - product.discount)) / 100).toFixed(
    2
  );

  return (
    <section itemScope itemType="https://schema.org/Product">
      <div className={cl.productcard}>
        <div className={cl.productcard_images}>
          <div>
            <img className={cl.big_image} src={mainImage} alt="" />
            <div className={cl.mini_images}>
              {product.images?.map((image) => (
                <img
                  src={image}
                  itemProp="image"
                  onMouseOver={onMouseOver(image)}
                  alt=""
                />
              ))}
            </div>
          </div>

          <div className={cl.main_productcard_bottons}>
            <button
              className={cl.main_productcard_addtocart}
              onClick={() => props.onAdd(product)}
            >
              <span>Add To Cart</span>
            </button>
            <NavLink style={{ display: "flex" }} to="/checkout">
              <button
                className={cl.main_productcard_buynow}
                onClick={() => props.onBuyItNow(product)}
              >
                Buy It Now
              </button>
            </NavLink>
          </div>
        </div>
        <div className={cl.main_productcard}>
          <h4 className={cl.main_productcard_name} itemProp="name">
            {product.name}
          </h4>
          <div style={{ display: "flex", gap: "10px" }}>
            <div style={{ width: "40%", textAlign: "left" }}>
              <div className={cl.main_productcard_sold}>
                <span>
                  <svg
                    className={cl.main_productcard_sold_svg}
                    stroke="var(--text)"
                    viewBox="0 0 20 19.84"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M15.8,9.65A1.88,1.88,0,0,0,14.69,9l.67-.86a.45.45,0,0,0-.08-.64.46.46,0,0,0-.64.08L13.58,9H6.34L5.17,7.64a.46.46,0,0,0-.64,0,.45.45,0,0,0,0,.64L5.18,9A1.91,1.91,0,0,0,4,9.88a2,2,0,0,0-.26,1.47l.72,4.37a1.92,1.92,0,0,0,1.82,1.69H13.7a1.89,1.89,0,0,0,1.79-1.66l.73-4.38a2.36,2.36,0,0,0,0-.28A1.94,1.94,0,0,0,15.8,9.65Zm-.48,1.55-.73,4.42a1,1,0,0,1-.92.88H6.35a1,1,0,0,1-.94-.9l-.73-4.43a1,1,0,0,1,.13-.81,1.1,1.1,0,0,1,.67-.48l.11,0h8.78a1.07,1.07,0,0,1,.73.38,1.05,1.05,0,0,1,.25.78A.74.74,0,0,1,15.32,11.2Z" />
                    <path d="M7.52,11.52a.47.47,0,0,0-.46.46v2.63a.46.46,0,0,0,.92,0V12A.47.47,0,0,0,7.52,11.52Z" />
                    <path d="M9.93,11.52a.46.46,0,0,0-.46.46v2.63a.46.46,0,0,0,.91,0V12A.46.46,0,0,0,9.93,11.52Z" />
                    <path d="M12.4,11.52A.46.46,0,0,0,12,12v2.63a.46.46,0,0,0,.91,0V12A.46.46,0,0,0,12.4,11.52Z" />
                    <path d="M9.59,8.57a.46.46,0,0,0,.68,0l2.81-3.11a.45.45,0,0,0,0-.64.46.46,0,0,0-.65,0L10.41,7V2.89a.46.46,0,1,0-.91,0V7.1l-2-2.25a.46.46,0,0,0-.68.61Z" />
                  </svg>
                  26.07K Sold
                </span>
              </div>
              <div className={cl.main_productcard_limited}>
                Each order is limited to $80, more than the amount can be placed
                separately!
              </div>
              <p
                className={cl.main_productcard_price}
                itemProp="offers"
                itemScope
                itemType="https://schema.org/Offer"
              >
                <span itemProp="price">
                  {product.currency}
                  {newPrice}
                </span>
              </p>
              <div className={cl.main_productcard_recomended}>
                <svg
                  className={cl.main_productcard_recomended_svg}
                  viewBox="0 0 32 32"
                >
                  <desc />
                  <g>
                    <rect
                      fill="none"
                      height="16"
                      stroke="var(--text)"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                      width="6"
                      x="3"
                      y="15"
                    />
                    <path
                      d="M9,15l5-5l2-7h0   c2.209,0,4,1.791,4,4v8h5h0c2.209,0,4,1.791,4,4v0l-1.721,10.329C27.118,30.293,26.283,31,25.306,31H9V15z"
                      fill="none"
                      stroke="var(--text)"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    />
                  </g>
                </svg>
                It's been recommended by 1.9K people
              </div>
              <div className={cl.main_productcard_recomended}>
                <svg
                  className={cl.main_productcard_recomended_svg}
                  stroke="var(--text)"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title />
                  <g data-name="Layer 2" id="Layer_2">
                    <path d="M12,5c-6.54,0-9.76,6.29-9.89,6.55L1.88,12l.22.45C2.24,12.71,5.46,19,12,19s9.76-6.29,9.89-6.55l.22-.45-.22-.45C21.76,11.29,18.54,5,12,5Zm0,12c-4.38,0-7-3.7-7.85-5C5,10.7,7.62,7,12,7s7,3.7,7.85,5C19,13.3,16.38,17,12,17Z" />
                    <path d="M12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z" />
                  </g>
                </svg>
                130 people are viewing this right now
              </div>
            </div>

            {/*  */}
            <div className={cl.description} itemProp="description">
              {product.description}
            </div>
          </div>
        </div>
      </div>
      <div className={cl.table_container}>
        {product.info ? (
          <div itemProp="description" className={cl.table_description}>
            <table style={{ maxWidth: "800px" }}>
              <tbody>
                {Object.entries(product.info).map(([key, value]) => (
                  <tr key={key}>
                    <td
                      style={{
                        fontWeight: "bold",
                        padding: "0.5rem 0rem 0.5rem 0.5rem",
                      }}
                    >
                      {key}
                    </td>
                    <td style={{ padding: "0.2rem" }}>{value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <> </>
        )}
        {product.features ? (
          <div
            itemProp="description"
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              margin: "3rem 0",
            }}
          >
            <p
              style={{
                marginBottom: "1.5rem",
                fontSize: "1.5rem",
                fontWeight: "bold",
                color: "var(--tertiary)",
              }}
            >
              Product features
            </p>
            <ul className={cl.product_features}>
              {product.features?.map((feature) => (
                <li style={{ margin: "0.5rem 0" }}>{feature}</li>
              ))}
            </ul>
          </div>
        ) : null}
      </div>

      <div className={cl.description}>{productDescrImages}</div>
      <Comments comments={product.comments} rating={product.rating} />
    </section>
  );
};

export default ProductCard;
